import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToasterService } from './toaster.service';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-toaster',
  standalone: true,
  imports: [CommonModule, MatIcon],
  templateUrl: './toaster.component.html',
  styleUrls: ['./toaster.component.scss']
})
export class ToasterComponent {
  readonly toaster = inject(ToasterService);

  getToastsByPosition(position: string) {
    return this.toaster.toasts().filter(t => t.position === position);
  }
}
